export const mockData = {
  // Language content
  languages: {
    it: {
      hero: {
        title: "Parla Inglese Come un CEO in Sole 10 Sedute",
        subtitle: "Il metodo scientifico depositato che ha trasformato oltre 5.000 executive italiani in speaker internazionali d'élite: risultati garantiti senza lasciare l'Italia.",
        ctaButtons: [
          { text: "Prenota Valutazione Gratuita", type: "primary" },
          { text: "Scopri il Metodo", type: "secondary" }
        ]
      },
      professor: {
        name: "Professor Steve Dapper",
        title: "L'Autorità Globale che Trasforma Executive Fortune 500",
        subtitle: "Quando Leadership Aziendale e Maestria Linguistica si Incontrano",
        titleRoles: "INTERNATIONAL BUSINESS DEVELOPER | ENGLISH PROFESSOR OF PHONETICS | FORTUNE 500 EXECUTIVE | PUBLISHED AUTHOR",
        experience: "oltre tre decenni",
        image: "https://customer-assets.emergentagent.com/job_modern-voice-1/artifacts/70px3i54__MG_2481.jpg",
        powerStatement: "L'unico professionista al mondo che combina 30+ anni di leadership Fortune 500 con autorità accademica in fonetica articolatoria—creando l'esperienza definitiva per executive che rifiutano compromessi nella comunicazione globale.",
        bio: "Professor Steve Dapper rappresenta una rarità assoluta nel panorama professionale globale: un executive Fortune 500 che è simultaneamente Professore Universitario di Fonetica Inglese. Questa combinazione unica di credenziali aziendali d'élite e autorità accademica scientifica lo posiziona come l'unico professionista qualificato a guidare leader corporate verso l'eccellenza comunicativa che definisce i veri protagonisti dei mercati internazionali.",
        corporateValue: "Per CEO, CFO e C-suite executives che operano in contesti multinazionali, Professor Dapper elimina il divario tra competenza linguistica e credibilità executive. Non è solo padronanza della pronuncia inglese—è acquisizione dell'autorevolezza vocale che distingue i leader globali da semplici manager. Quando dirigenti Fortune 500 devono negoziare acquisizioni multimilionarie, presentare a board internazionali o guidare call strategiche con stakeholder globali, la precisione articolatoria diventa un asset strategico non negoziabile.",
        description: "La carriera di Professor Steve Dapper attraversa tre decenni di risultati eccezionali in due domini apparentemente distinti ma strategicamente complementari. Nel mondo corporate, ha operato come International Business Developer e Fortune 500 Executive, guidando iniziative transatlantiche che hanno ridefinito mercati e creato valore per miliardi di dollari. Ha consigliato direttamente governi statunitensi ed europei attraverso il U.S. Department of Commerce, AMCHAM e Select USA, posizionandosi come ponte strategico tra superpotenze economiche e mercati emergenti. Nel panorama accademico, Professor Dapper detiene la cattedra di Professore di Fonetica Inglese nelle più prestigiose istituzioni educative europee, dove la sua ricerca pionieristica in fonetica articolatoria ESOL ha rivoluzionato l'approccio scientifico all'acquisizione linguistica per adulti. Il suo metodo VocalFitness—depositato e validato da enti di calibro mondiale come EF Education First, Cambridge Assessment e MIUR—è integrato nelle app linguistiche leader globali (EWA, Elsa Speak, ABA English) che servono milioni di professionisti internazionali. Come Published Author e Executive Producer, ha collaborato con studi Hollywood e major discografiche, mentre la sua serie 'Dappersclass' raggiunge audience globali attraverso piattaforme streaming, consolidando la sua influenza come comunicatore di livello mondiale. Questa convergenza di eccellenza corporate e autorità accademica crea un'esperienza di trasformazione vocale senza precedenti per leader che esigono risultati misurabili e duraturi.",
        roles: [
          "Fortune 500 Executive & International Business Developer",
          "Professore Universitario di Fonetica Inglese", 
          "Consulente Governativo USA/Europa",
          "Published Author & Executive Producer",
          "Creatore del Metodo VocalFitness Depositato"
        ],
        achievements: [
          "30+ anni di leadership Fortune 500 in mercati USA/Europa",
          "Cattedra di Professore di Fonetica nelle top istituzioni europee",
          "Consulente ufficiale: U.S. Department of Commerce, AMCHAM, Select USA",
          "Metodo validato da EF, Cambridge Assessment, MIUR",
          "Integrazione in app globali: EWA, Elsa Speak, ABA English (milioni di utenti)",
          "Dappersclass: serie edutainment con reach globale multimilionario"
        ],
        credibilityMarkers: [
          "Unico professionista con doppia autorità: Corporate Fortune 500 + Accademica Universitaria",
          "Metodo depositato riconosciuto da enti internazionali",
          "Track record documentato di trasformazione vocale per C-suite executives",
          "Consulenza diretta a governi e multinazionali per oltre tre decenni"
        ]
      }
    },
    en: {
      hero: {
        title: "Speak English Like a CEO in Just 10 Sessions",
        subtitle: "The registered scientific method that has transformed over 5,000 Italian executives into elite international speakers: guaranteed results without leaving Italy.",
        ctaButtons: [
          { text: "Book Free Assessment", type: "primary" },
          { text: "Discover the Method", type: "secondary" }
        ]
      },
      professor: {
        name: "Professor Steve Dapper",
        title: "The Global Authority Transforming Fortune 500 Executives",
        subtitle: "Where Corporate Leadership Meets Linguistic Mastery",
        titleRoles: "INTERNATIONAL BUSINESS DEVELOPER | ENGLISH PROFESSOR OF PHONETICS | FORTUNE 500 EXECUTIVE | PUBLISHED AUTHOR",
        experience: "over three decades",
        image: "https://customer-assets.emergentagent.com/job_modern-voice-1/artifacts/70px3i54__MG_2481.jpg",
        powerStatement: "The only professional worldwide combining 30+ years of Fortune 500 leadership with academic authority in articulatory phonetics—creating the definitive experience for executives who refuse compromise in global communication.",
        bio: "Professor Steve Dapper represents an absolute rarity in the global professional landscape: a Fortune 500 executive who is simultaneously a University Professor of English Phonetics. This unique combination of elite corporate credentials and scientific academic authority positions him as the only professional qualified to guide corporate leaders toward the communicative excellence that defines true protagonists of international markets.",
        corporateValue: "For CEOs, CFOs, and C-suite executives operating in multinational contexts, Professor Dapper eliminates the gap between linguistic competence and executive credibility. This isn't just mastering English pronunciation—it's acquiring the vocal authority that distinguishes global leaders from mere managers. When Fortune 500 executives must negotiate multimillion-dollar acquisitions, present to international boards, or lead strategic calls with global stakeholders, articulatory precision becomes a non-negotiable strategic asset.",
        description: "Professor Steve Dapper's career spans three decades of exceptional achievements across two seemingly distinct but strategically complementary domains. In the corporate world, he has operated as an International Business Developer and Fortune 500 Executive, leading transatlantic initiatives that have redefined markets and created billions in value. He has directly advised U.S. and European governments through the U.S. Department of Commerce, AMCHAM, and Select USA, positioning himself as a strategic bridge between economic superpowers and emerging markets. In the academic landscape, Professor Dapper holds the chair of Professor of English Phonetics at Europe's most prestigious educational institutions, where his pioneering research in ESOL articulatory phonetics has revolutionized the scientific approach to adult language acquisition. His VocalFitness method—registered and validated by world-class entities like EF Education First, Cambridge Assessment, and MIUR—is integrated into leading global language apps (EWA, Elsa Speak, ABA English) serving millions of international professionals. As a Published Author and Executive Producer, he has collaborated with Hollywood studios and major record labels, while his 'Dappersclass' series reaches global audiences through streaming platforms, consolidating his influence as a world-class communicator. This convergence of corporate excellence and academic authority creates an unprecedented vocal transformation experience for leaders who demand measurable and lasting results.",
        roles: [
          "Fortune 500 Executive & International Business Developer",
          "University Professor of English Phonetics", 
          "U.S./European Government Consultant",
          "Published Author & Executive Producer",
          "Creator of the Registered VocalFitness Method"
        ],
        achievements: [
          "30+ years of Fortune 500 leadership across U.S./European markets",
          "Chair Professor of Phonetics at top European institutions",
          "Official consultant: U.S. Department of Commerce, AMCHAM, Select USA",
          "Method validated by EF, Cambridge Assessment, MIUR",
          "Global app integration: EWA, Elsa Speak, ABA English (millions of users)",
          "Dappersclass: edutainment series with multimillion global reach"
        ],
        credibilityMarkers: [
          "Only professional with dual authority: Fortune 500 Corporate + University Academic",
          "Registered method recognized by international entities",
          "Documented track record of vocal transformation for C-suite executives",
          "Direct consultation to governments and multinationals for over three decades"
        ]
      }
    }
  },

  // Shared data that doesn't need translation
  professor: {
    name: "Professor Steve Dapper",
    title: "L'Architetto della Comunicazione Globale",
    experience: "oltre tre decenni",
    roles: [
      "Fortune 500 Executive",
      "Global Business Developer", 
      "Professore di Fonetica Inglese",
      "Autore Pubblicato",
      "Voice Artist"
    ],
    achievements: [
      "Consulenza a governi USA ed europei",
      "U.S. Department of Commerce, AMCHAM, Select USA",
      "Metodo approvato da EF, Cambridge Assessment, MIUR",
      "Integrato in EWA, Elsa Speak, ABA English",
      "Creatore di Dappersclass (milioni di visualizzazioni)"
    ]
  },

  method: {
    it: {
      title: "La Scienza Dietro VocalFitness",
      subtitle: "Tre Pilastri Fondamentali",
      pillars: [
        {
          number: "01",
          title: "Fonetica Articolatoria ESOL",
          description: "Analisi dettagliata del posizionamento linguale, configurazione labiale, movimento mandibolare e controllo del flusso d'aria per padronanza precisa dei fonemi."
        },
        {
          number: "02", 
          title: "Prosodia Avanzata",
          description: "Pattern soprasegmentali: intonazione, ritmo, accentuazione sillabica e timing che comunicano significato, emozione e intenzione."
        },
        {
          number: "03",
          title: "Condizionamento Muscolare",
          description: "Coordinazione neuromuscolare sofisticata attraverso esercizi progressivi che sviluppano memoria muscolare articolatoria."
        }
      ]
    },
    en: {
      title: "The Science Behind VocalFitness",
      subtitle: "Three Fundamental Pillars",
      pillars: [
        {
          number: "01",
          title: "ESOL Articulatory Phonetics",
          description: "Detailed analysis of tongue positioning, lip configuration, jaw movement, and airflow control for precise phoneme mastery."
        },
        {
          number: "02", 
          title: "Advanced Prosody",
          description: "Suprasegmental patterns: intonation, rhythm, syllabic stress, and timing that communicate meaning, emotion, and intention."
        },
        {
          number: "03",
          title: "Muscle Conditioning",
          description: "Sophisticated neuromuscular coordination through progressive exercises that develop articulatory muscle memory."
        }
      ]
    }
  },

  stats: [
    { value: "96%", label: "Comprensibilità Aumentata" },
    { value: "8-12", label: "Settimane al Cambiamento" },
    { value: "89%", label: "Avanzamento Carriera" },
    { value: "100%", label: "Soddisfazione Cliente" }
  ],

  targetAudience: [
    {
      title: "Dirigenti Multinazionali",
      description: "CEO, CFO e leader C-suite che devono proiettare autorità attraverso barriere linguistiche.",
      icon: "briefcase"
    },
    {
      title: "Professionisti Internazionali", 
      description: "Manager e consulenti che collaborano quotidianamente con colleghi anglofoni.",
      icon: "globe"
    },
    {
      title: "Attori e Cantanti",
      description: "Performer che richiedono controllo dialettale impeccabile per autenticità artistica.",
      icon: "mic"
    },
    {
      title: "Leader Accademici",
      description: "Professori e ricercatori che comunicano idee complesse a audience diverse.",
      icon: "graduation-cap"
    },
    {
      title: "Aziende e Team",
      titleEn: "Companies & Teams",
      description: "Formazione aziendale completa per tutti i dipendenti con il metodo VocalFitness incluso.",
      descriptionEn: "Complete corporate training for all employees with VocalFitness method included.",
      icon: "building",
      link: "/corporate-training",
      highlight: true
    }
  ],

  process: {
    it: [
      {
        step: "01",
        title: "Valutazione Fonologica Comprensiva",
        description: "Analisi diagnostica dettagliata che mappa pattern articolatori esistenti e identifica sostituzioni fonetiche specifiche."
      },
      {
        step: "02", 
        title: "Progettazione Protocollo Personalizzato",
        description: "Protocollo training individualizzato basato sui risultati diagnostici dello studente."
      },
      {
        step: "03",
        title: "Condizionamento Neuromuscolare Intensivo",
        description: "Esercizi progressivi che ricondizionano muscolatura articolatoria con feedback immediato."
      },
      {
        step: "04",
        title: "Integrazione Prosodia",
        description: "Training su pattern prosodici e applicazione in scenari professionali realistici."
      },
      {
        step: "05",
        title: "Consolidamento e Valutazione",
        description: "Valutazioni periodiche e strategie di mantenimento a lungo termine."
      }
    ],
    en: [
      {
        step: "01",
        title: "Comprehensive Phonological Assessment",
        description: "Detailed diagnostic analysis mapping existing articulatory patterns and identifying specific phonetic substitutions."
      },
      {
        step: "02", 
        title: "Personalized Protocol Design",
        description: "Individualized training protocol based on the student's diagnostic results."
      },
      {
        step: "03",
        title: "Intensive Neuromuscular Conditioning",
        description: "Progressive exercises reconditioning articulatory musculature with immediate feedback."
      },
      {
        step: "04",
        title: "Prosody Integration",
        description: "Training on prosodic patterns and application in realistic professional scenarios."
      },
      {
        step: "05",
        title: "Consolidation and Evaluation",
        description: "Periodic assessments and long-term maintenance strategies."
      }
    ]
  },

  testimonials: [
    {
      text: "VocalFitness ha trasformato radicalmente la mia capacità di comunicare con chiarezza cristallina nelle riunioni esecutive internazionali. Il metodo del Professor Dapper va oltre l'accento—ha ricostruito fondamentalmente come produco suoni inglesi.",
      author: "Executive Fortune 100",
      role: "Settore Tecnologico"
    },
    {
      text: "Come cantante internazionale, dizione impeccabile è non negoziabile. VocalFitness ha perfezionato la mia articolazione inglese a un livello che critici musicali non riescono a rilevare il mio background linguistico.",
      author: "Soprano",
      role: "Metropolitan Opera"
    },
    {
      text: "Dopo anni di frustrazione con programmi generici, VocalFitness ha finalmente sbloccato la mia capacità di comunicare con autorità nelle presentazioni board. Ora comando sale riunioni con fiducia vocale.",
      author: "CFO", 
      role: "Multinazionale Farmaceutica"
    }
  ],

  successStories: {
    it: [
      {
        number: "1",
        title: "Tech Leader - Dalla Confusione alla Leadership Globale",
        sector: "Tecnologia",
        challenge: "Un leader nello sviluppo software, con un italiano di livello A2, faticava a essere percepito come autorevole nelle riunioni internazionali.",
        result: "In sole 10 lezioni, ha raggiunto una pronuncia di livello C1+. Ha guidato con successo un'acquisizione internazionale e è stato promosso a Direttore Tecnico Internazionale."
      },
      {
        number: "2",
        title: "Ricercatrice Farmaceutica - Riconoscimento Internazionale", 
        sector: "Farmaceutico",
        challenge: "Una brillante ricercatrice senior provava imbarazzo nel presentare le sue scoperte a conferenze globali.",
        result: "Dopo 8 settimane ha raggiunto il livello C2. Ha presentato al World Medical Congress con clamoroso successo, attirando finanziamenti significativi."
      },
      {
        number: "3",
        title: "Analista Finanziario - Accordo Milionario",
        sector: "Finanziario", 
        challenge: "Un analista di private equity si sentiva insicuro durante le negoziazioni ad alto rischio con investitori anglofoni.",
        result: "Ha conquistato una pronuncia fluida di livello C2 in 10 lezioni. Ha chiuso due accordi multimilionari e è stato promosso a Partner Associato."
      },
      {
        number: "4",
        title: "Attore Cinematografico - Da Ruoli Secondari a Protagonista",
        sector: "Entertainment",
        challenge: "Un talentuoso attore teatrale italiano perdeva audizioni per produzioni hollywoodiane a causa del suo marcato accento che lo limitava a ruoli stereotipati.",
        result: "Dopo 12 settimane di VocalFitness ha raggiunto articolazione C2. Ha ottenuto il ruolo da protagonista in una serie Netflix internazionale e firmato con una major agency di Los Angeles."
      },
      {
        number: "5",
        title: "Chirurgo Cardiaco - Leadership Medica Globale",
        sector: "Medicina",
        challenge: "Un chirurgo cardiaco di fama europea esitava ad accettare inviti per presentare tecniche innovative in congressi USA a causa dell'insicurezza nella pronuncia inglese.",
        result: "In 10 settimane ha perfezionato la pronuncia al livello C2. Ha tenuto keynote al American College of Cardiology, è stato nominato visiting professor a Johns Hopkins e ha pubblicato su NEJM."
      },
      {
        number: "6",
        title: "Project Manager Aerospaziale - Contratti Internazionali",
        sector: "Engineering",
        challenge: "Un ingegnere aerospaziale senior perdeva credibilità con clienti NASA e ESA durante presentazioni tecniche a causa di pronuncia poco chiara di terminologia tecnica.",
        result: "VocalFitness lo ha portato da B1 a C2 in 8 settimane. Ha guidato negoziazioni per un contratto da €45M con l'ESA ed è stato promosso a Director of International Programs."
      },
      {
        number: "7",
        title: "CMO - Da Manager Regionale a Leader Globale",
        sector: "Sales & Marketing",
        challenge: "Una Chief Marketing Officer italiana con risultati brillanti in Europa veniva ripetutamente scavalcata per posizioni C-suite globali a causa di percezioni sulla sua autorevolezza comunicativa.",
        result: "Dopo 10 sessioni VocalFitness ha raggiunto livello C2. È stata nominata Global CMO di una Fortune 500, gestendo team in 47 paesi con budget di $800M."
      },
      {
        number: "8",
        title: "Avvocato Internazionale - Arbitrati Multimilionari",
        sector: "Legal",
        challenge: "Un avvocato specializzato in arbitrato internazionale perdeva casi critici perché le sue argomentazioni orali non avevano l'impatto persuasivo dei colleghi anglofoni nativi.",
        result: "VocalFitness lo ha trasformato in 12 settimane (livello C2). Ha vinto 4 arbitrati consecutivi per un valore totale di €120M e è stato nominato partner equity nel suo studio."
      },
      {
        number: "9",
        title: "Direttore Hospitality - Espansione Luxury Globale",
        sector: "Aviation & Hospitality",
        challenge: "Un general manager di hotel di lusso eccelleva operativamente ma veniva bloccato nelle promozioni corporate a causa dell'accento che minava la sua immagine executive con clienti internazionali VIP.",
        result: "In 10 settimane ha raggiunto pronuncia C1+. È stato promosso a Regional Director per Europa e Medio Oriente di una catena luxury internazionale, supervisionando 23 proprietà."
      }
    ],
    en: [
      {
        number: "1",
        title: "Tech Leader - From Confusion to Global Leadership",
        sector: "Technology",
        challenge: "A software development leader, with A2 level English, struggled to be perceived as authoritative in international meetings.",
        result: "In just 10 lessons, achieved C1+ pronunciation. Successfully led an international acquisition and was promoted to International Technical Director."
      },
      {
        number: "2",
        title: "Pharmaceutical Researcher - International Recognition", 
        sector: "Pharmaceutical",
        challenge: "A brilliant senior researcher felt embarrassed presenting her discoveries at global conferences.",
        result: "After 8 weeks reached C2 level. Presented at World Medical Congress with resounding success, attracting significant funding."
      },
      {
        number: "3",
        title: "Financial Analyst - Million Dollar Deal",
        sector: "Financial", 
        challenge: "A private equity analyst felt insecure during high-stakes negotiations with English-speaking investors.",
        result: "Achieved fluent C2 pronunciation in 10 lessons. Closed two multimillion-dollar deals and was promoted to Associate Partner."
      },
      {
        number: "4",
        title: "Film Actor - From Supporting Roles to Lead",
        sector: "Entertainment",
        challenge: "A talented Italian theater actor lost auditions for Hollywood productions due to his marked accent limiting him to stereotypical roles.",
        result: "After 12 weeks of VocalFitness achieved C2 articulation. Secured lead role in international Netflix series and signed with major Los Angeles agency."
      },
      {
        number: "5",
        title: "Cardiac Surgeon - Global Medical Leadership",
        sector: "Medicine",
        challenge: "A renowned European cardiac surgeon hesitated accepting invitations to present innovative techniques at U.S. congresses due to English pronunciation insecurity.",
        result: "In 10 weeks perfected pronunciation to C2 level. Delivered keynote at American College of Cardiology, appointed visiting professor at Johns Hopkins, published in NEJM."
      },
      {
        number: "6",
        title: "Aerospace Project Manager - International Contracts",
        sector: "Engineering",
        challenge: "A senior aerospace engineer lost credibility with NASA and ESA clients during technical presentations due to unclear pronunciation of technical terminology.",
        result: "VocalFitness brought him from B1 to C2 in 8 weeks. Led negotiations for €45M ESA contract and was promoted to Director of International Programs."
      },
      {
        number: "7",
        title: "CMO - From Regional Manager to Global Leader",
        sector: "Sales & Marketing",
        challenge: "An Italian Chief Marketing Officer with brilliant European results was repeatedly passed over for global C-suite positions due to perceptions about her communication authority.",
        result: "After 10 VocalFitness sessions reached C2 level. Appointed Global CMO of Fortune 500 company, managing teams in 47 countries with $800M budget."
      },
      {
        number: "8",
        title: "International Lawyer - Multimillion Arbitrations",
        sector: "Legal",
        challenge: "A lawyer specializing in international arbitration lost critical cases because his oral arguments lacked the persuasive impact of native English-speaking colleagues.",
        result: "VocalFitness transformed him in 12 weeks (C2 level). Won 4 consecutive arbitrations totaling €120M and was named equity partner at his firm."
      },
      {
        number: "9",
        title: "Hospitality Director - Luxury Global Expansion",
        sector: "Aviation & Hospitality",
        challenge: "A luxury hotel general manager excelled operationally but was blocked from corporate promotions due to accent undermining his executive image with VIP international clients.",
        result: "In 10 weeks achieved C1+ pronunciation. Promoted to Regional Director for Europe and Middle East of international luxury chain, overseeing 23 properties."
      }
    ]
  }
};